export const injectCssPropertiesIntoRootElementMutatorFactory = (cssProps, _experiments) => (el) => {
    Object.keys(cssProps).forEach((key) => {
        if (!el.css(key)) {
            el.css(key, cssProps[key]);
        }
    });
};
//# sourceMappingURL=inject-css-properties-into-root-element.js.map